import alphaKaz from '@/modules/validators/alphaKaz';
import phoneOrEmail from '@/modules/validators/phoneOrEmail';

export default {
    ...alphaKaz,
    ...phoneOrEmail
}
